import { STATUS_CODE } from '@kc-console/core';

import type { Env, ServiceAppState } from '@kc-console/context';

export const INITIAL_DEFAULT_STATE: ServiceAppState = {
  status: STATUS_CODE.OK,
  redirect: null,
  env: (process.env.KC_ENV as Env) || 'stage',
  bffEndpoint: '',
  iamEndpoint: '',
  iamSSREndpoint: '',
  token: '',
  domainId: '',
  domainName: '',
  projectId: '',
  projectName: '',
  serviceKeyword: 'status',
  region: undefined,
  language: '',
  displayLanguage: '',
  scope: 'unscope',
  userId: '',
  userName: '',
  defaultProjectId: '',
  accessibleProjects: [],
  error: null,
  isRegionForced: false,
  isProjectForced: false,
  ssrConfig: null,
};

export const ERROR_PAGE_DEFAULT_STATE: ServiceAppState = {
  status: STATUS_CODE.OK,
  redirect: null,
  env: (process.env.KC_ENV as Env) || 'stage',
  bffEndpoint: '',
  iamEndpoint: '',
  iamSSREndpoint: '',
  token: '',
  domainId: '',
  domainName: '',
  projectId: '',
  projectName: '',
  serviceKeyword: 'status',
  region: undefined,
  language: '',
  displayLanguage: '',
  scope: 'unscope',
  userId: '',
  userName: '',
  defaultProjectId: '',
  accessibleProjects: [],
  error: null,
  isRegionForced: false,
  isProjectForced: false,
  ssrConfig: null,
};
